export const de = {
    code: "de",
    country: "DE",
    translations: {
        news: "News",
        events: "Veranstaltungen",
        more: "Mehr laden",
        all: "Alle",
        result: "Ergebnis",
        results: "Ergebnisse",
        results_filter_txt: "zur getroffenen Filterauswahl",
        filter_topic_title: "Thema",
        filter_topic_choose: "Thema auswählen",
        filter_topic_button: "Anwenden",
        filter_topic_dropdown_placeholder: "Filterbereich für Themenauswahl",
        filter_time_title: "Zeitraum",
        filter_time_choose: "Zeitraum auswählen",
        filter_time_button: "Anwenden",
        filter_time_dropdown_placeholder: "Filterbereich für Zeitraumauswahl",
        filter_time_errordate: "Bitte prüfen Sie ob ein korrektes Datum eingegeben wurde und ob das Startdatum vor dem Enddatum liegt.",
        filter_active_zone_title: "Ihre Filterauswahl",
        filter_active_zone_delete: "Filter zurücksetzen",
        timeItems_buttons_7_title: "Nächsten 7 Tage",
        timeItems_buttons_30_title: "Nächsten 30 Tage",
        timeItems_inputs_start_label: "Start",
        timeItems_inputs_start_placeholder: "Datum",
        timeItems_inputs_end_label: "Ende",
        timeItems_inputs_end_placeholder: "Datum",
    }
};
